import { Tag } from 'api/api-rtk'

import store from '../../../redux/store'
import { workspaceApi } from '../api'

export function refetchStatistics() {
	const action = workspaceApi.util.invalidateTags([Tag.WorkspaceStats])
	return store.dispatch(action)
}
